import { Button } from "@evertrue/et-components";
import { PropTypes } from "base/react-libs";
import { useGlobalJourneyProvider } from "apps/journeys/context/global-journey-context";
import Avatar from "components/elements/avatar";
import EverTrue from "app";
import ContactTimezoneIndicator from "apps/contact/components/contact-timezone-indicator";

const getYear = (contact) => {
  const { contact_attributes = {} } = contact;

  if (contact_attributes) {
    const { year } = contact_attributes;
    if (year) return `Class of ${year}`;
  }

  return null;
};

const getRoleWithYear = (contact = {}) => {
  const { constituencies = [] } = contact;
  let roles;

  if (constituencies.length) {
    const statuses = constituencies.map((c) => c.status).filter((s) => !!s);
    if (statuses.length) {
      roles = statuses.join(", ").replace(";", "");
    }
  }

  const year = getYear(contact);

  if (roles && year) return `${roles} - ${year}`;
  else if (roles) return roles;
  else if (year) return year;
  else return "";
};

const TaskRowDetailsContactCard = ({
  contact,
  avatarSize = 40,
  padding = 8,
  householdCard = false,
  currentJourney = {},
}) => {
  const { setGlobalJourney } = useGlobalJourneyProvider();

  if (!contact && !Object.keys(contact).length) return null;

  const { contact_attributes = {}, profile_image = {} } = contact;
  const avatarUrl = profile_image ? profile_image.url : null;

  return (
    <div
      data-testid="journeys--contact-card"
      className="journeys--contact-card--container"
      style={{ padding: padding }}
    >
      <Avatar url={avatarUrl} name={contact_attributes.name_full} width={avatarSize} />
      <div className="journeys--contact-card--content fs-exclude-data">
        <div className="journeys--contact-card-main">
          <Button
            className="journeys-contact-card-name"
            type="simple"
            onClick={() => {
              setGlobalJourney(currentJourney);
              EverTrue.Navigator(`/contact/${contact.id}`, true);
            }}
          >
            {contact_attributes.name_full}
          </Button>
          <ContactTimezoneIndicator contact={contact} />
        </div>
        {householdCard ? (
          <>
            <div>Household Member</div>
            <div>Household</div>
          </>
        ) : (
          <div>{getRoleWithYear(contact)}</div>
        )}
      </div>
    </div>
  );
};

TaskRowDetailsContactCard.propTypes = {
  contact: PropTypes.object,
  avatarSize: PropTypes.number,
  padding: PropTypes.number,
  householdCard: PropTypes.bool,
  currentJourney: PropTypes.object,
};

export default TaskRowDetailsContactCard;
